export class AssignerTaskAvecDelai 
{
    causeAssignation:string;
    taskId:string;
    username:string;
    dueDate:string;
}